import { all, call, put, takeLatest } from 'redux-saga/effects';

import { setError } from './actions';
import { IErrorType } from '../../constants/types';
import { showToastMessage } from '../../utils/AppUtils';
import { SentryCapture } from '../../analytics/Sentry';
import { types } from './types';
import { Action } from 'redux';

function safeUserMessage(data: { message?: unknown; status?: string } | null | undefined): string {
    const m = data?.message;
    if (typeof m === 'string' && m.trim()) return m;
    if (m != null && typeof m !== 'object') return String(m);
    return 'Please try again';
}

export function* globalErrorHandler(payload: IErrorType) {
    const { data, statusText, status } = payload || {};

    let errorHeader = statusText;
    if (status === 401) errorHeader = 'UnAuthorized';
    const userMessage = safeUserMessage(data as { message?: unknown; status?: string } | null);
    if (data && (statusText || data.status)) {
        yield put(setError({ errorHeader, errorBody: userMessage }));
    } else {
        yield put(setError({ errorHeader: 'Something went wrong', errorBody: 'Please try again' }));
    }
    if (data && data.message) {
        yield call(showToastMessage, userMessage, 'error');
    } else {
        yield call(showToastMessage, 'Something went wrong', 'error');
    }
    yield call(SentryCapture, payload, 'error');
}

export function* globalHandler({ payload }: { payload: IErrorType }) {
    const { data, statusText, status } = payload || {};

    let errorHeader = statusText;
    if (status === 401) errorHeader = 'UnAuthorized';
    const userMessage = safeUserMessage(data as { message?: unknown; status?: string } | null);
    if (data && (statusText || data.status)) {
        yield put(setError({ errorHeader, errorBody: userMessage }));
    } else {
        yield put(setError({ errorHeader: 'Something went wrong', errorBody: 'Please try again' }));
    }
    if (data && data.message) {
        yield call(showToastMessage, userMessage, 'error');
    } else {
        yield call(showToastMessage, 'Something went wrong', 'error');
    }
    yield call(SentryCapture, payload, 'error');
}

interface TaskAction extends Action {
    payload: IErrorType;
    data: any;
    statusText: any;
    status: any;
}

function* errorHandlerWatcher() {
    yield takeLatest<TaskAction>(types.SET_SOCKET_ERROR, globalHandler);
}

export default function* errorSaga() {
    yield all([errorHandlerWatcher()]);
}
